import type { JSX } from "react";
export interface StatCard {
  readonly value: string;
  readonly label: string;
}

export interface StatsGridProps {
  readonly stats: readonly StatCard[];
}

/**
 * 2-column grid of stat cards showing value/label pairs.
 * Used in contacts sidebar, tasks sidebar.
 */
export function StatsGrid({ stats }: StatsGridProps): JSX.Element {
  return (
    <div className="grid grid-cols-2 gap-3">
      {stats.map((stat) => (
        <div className="bg-surface-hover p-3 rounded-[10px]" key={stat.label}>
          <div className="text-lg font-semibold">{stat.value}</div>
          <div className="text-[10px] text-content-tertiary">{stat.label}</div>
        </div>
      ))}
    </div>
  );
}
